export class CommoditiesEnvironment {
  public static getName = () => 'benzinga-commodities';
  public static getEnvironment = (env: Record<string, string>) => ({
    key: env.key ?? '',
    url: new URL(env.url ?? 'https://www.benzinga.com/lavapress/api/'),
  });
}
